<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentdata.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
  
    <div>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Cancellation notes</mat-label>
        <textarea
          [(ngModel)]="notes"
          matInput
        ></textarea>
        <mat-icon matSuffix class="material-icons-outlined">description</mat-icon>
      </mat-form-field>
    </div>

  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        !notes
      "
      (click)="onPost()"
    >
      Confirm
    </button>
  </mat-dialog-actions>
  